import { getItemsExtras, putPagarCompraExtra } from "../services/comprasService";

const dataInicial = {
    listExtrasItemsAceptadas: [],
    pagina: 0,
    registros: 10,
    busqueda: "NA",
    total: 0,
    exito: 0,
}

const GET_EXTRAS_CONTRATADOS_ACEPTADAS_ALL = "GET_EXTRAS_CONTRATADOS_ACEPTADAS_ALL"
const GET_EXTRAS_CONTRATADOS_ACEPTADAS_PAGINA = "GET_EXTRAS_CONTRATADOS_ACEPTADAS_PAGINA"
const GET_EXTRAS_CONTRATADOS_ACEPTADAS_REGISTROS = "GET_EXTRAS_CONTRATADOS_ACEPTADAS_REGISTROS"
const GET_EXTRAS_CONTRATADOS_ACEPTADAS_BUSQUEDA = "GET_EXTRAS_CONTRATADOS_ACEPTADAS_BUSQUEDA"
const PUT_EXTRAS_CONTRATADOS_ACEPTADAS_ENVIAR_PAGO = "PUT_EXTRAS_CONTRATADOS_ACEPTADAS_ENVIAR_PAGO"
//* metodos para finanzas
export default function extrasContratadosAceptadasReducer(state = dataInicial, action) {
    switch (action.type) {
        case PUT_EXTRAS_CONTRATADOS_ACEPTADAS_ENVIAR_PAGO:
            return { ...state, exito: action.payload.exito }
        case GET_EXTRAS_CONTRATADOS_ACEPTADAS_ALL:
            return { ...state, listExtrasItemsAceptadas: action.payload.listExtrasItemsAceptadas, total: action.payload.total }
        case GET_EXTRAS_CONTRATADOS_ACEPTADAS_PAGINA:
            return { ...state, listExtrasItemsAceptadas: action.payload.listExtrasItemsAceptadas, pagina: action.payload.pagina, total: action.payload.total }
        case GET_EXTRAS_CONTRATADOS_ACEPTADAS_REGISTROS:
            return { ...state, listExtrasItemsAceptadas: action.payload.listExtrasItemsAceptadas, registros: action.payload.registros, total: action.payload.total }
        case GET_EXTRAS_CONTRATADOS_ACEPTADAS_BUSQUEDA:
            return { ...state, listExtrasItemsAceptadas: action.payload.listExtrasItemsAceptadas, busqueda: action.payload.busqueda, total: action.payload.total, pagina: action.payload.pagina, registros: action.payload.registros }
        default:
            return state;
    }
}
export const pagarItemExtrraAction = ({ idCompra }) => async (dispatch) => {
    return await putPagarCompraExtra({ idCompra }).then(Response => {
        dispatch({
            type: PUT_EXTRAS_CONTRATADOS_ACEPTADAS_ENVIAR_PAGO,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerExtrasAceptadasAction = () => async (dispatch, getSate) => {
    const { busqueda, pagina, registros } = getSate().extrasContratadosAprobados
    return await getItemsExtras({ Pagina: pagina + 1, Referencia: busqueda, Registros: registros }).then(Response => {
        dispatch({
            type: GET_EXTRAS_CONTRATADOS_ACEPTADAS_ALL,
            payload: {
                listExtrasItemsAceptadas: Response.LCompra,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerExtrasAceptadasPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { busqueda, registros } = getSate().extrasContratadosAprobados
    return await getItemsExtras({ Pagina: Pagina + 1, Referencia: busqueda, Registros: registros }).then(Response => {
        dispatch({
            type: GET_EXTRAS_CONTRATADOS_ACEPTADAS_PAGINA,
            payload: {
                listExtrasItemsAceptadas: Response.LCompra,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerExtrasAceptadasRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { busqueda, pagina } = getSate().extrasContratadosAprobados
    return await getItemsExtras({ Referencia: busqueda, Pagina: pagina + 1, Registros }).then(Response => {
        dispatch({
            type: GET_EXTRAS_CONTRATADOS_ACEPTADAS_REGISTROS,
            payload: {
                listExtrasItemsAceptadas: Response.LCompra,
                total: Response.Total,
                registros: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerExtrasAceptadasBusquedaAction = ({ Referencia }) => async (dispatch, getSate) => {
    return await getItemsExtras({ Referencia: Referencia, Pagina: dataInicial.pagina + 1, Registros: dataInicial.registros }).then(Response => {
        dispatch({
            type: GET_EXTRAS_CONTRATADOS_ACEPTADAS_BUSQUEDA,
            payload: {
                listExtrasItemsAceptadas: Response.LCompra,
                total: Response.Total,
                busqueda: Referencia,
                registros: dataInicial.registros,
                pagina: dataInicial.pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
